import { FieldArray } from 'formik';
import { useTranslation } from 'react-i18next';

import { SelectItem } from 'components/inputs/select/select';

import { FORM_FIELDS, LABELS } from '../../keys';
import { SectionRow } from '../../styles';
import Checkbox from '../checkbox/checkbox';
import Documents from '../documents/documents';
import { FieldStatusBadge } from '../fieldStatusBadge/FieldStatusBadge';
import IdentifyingInformation from '../identifyingInformation/identifyingInformation';
import { Container } from './styles';

interface StepFormProps {
  error?: Record<string, string>;
  countries: SelectItem[];
  clearBackendErrors?: () => void;
  isPartialMode?: boolean;
}

export default ({ error, countries, clearBackendErrors, isPartialMode = false }: StepFormProps) => {
  const { t } = useTranslation();

  return (
    <Container>
      <SectionRow>
        <Checkbox
          text={t(LABELS.SECTIONS.HAS_MATERIAL_INTERMEDIARY_OWNERSHIP.TEXT)}
          label={t(LABELS.SECTIONS.HAS_MATERIAL_INTERMEDIARY_OWNERSHIP.LABEL)}
          fieldPath={FORM_FIELDS.HAS_MATERIAL_INTERMEDIARY_OWNERSHIP}
          isPartialMode={isPartialMode}
        />
        <FieldStatusBadge fieldName={FORM_FIELDS.HAS_MATERIAL_INTERMEDIARY_OWNERSHIP} />
      </SectionRow>
      <FieldArray
        render={({ insert, remove }) => (
          <IdentifyingInformation
            error={error}
            insert={insert}
            remove={remove}
            countries={countries}
            fieldPath={FORM_FIELDS.IDENTIFYING_INFORMATION}
            clearBackendErrors={clearBackendErrors}
            isPartialMode={isPartialMode}
          />
        )}
        name={FORM_FIELDS.IDENTIFYING_INFORMATION}
      />
      <FieldArray
        render={({ insert, remove }) => (
          <Documents
            error={error}
            insert={insert}
            remove={remove}
            fieldPath={FORM_FIELDS.DOCUMENTS}
            clearBackendErrors={clearBackendErrors}
            isPartialMode={isPartialMode}
          />
        )}
        name={FORM_FIELDS.DOCUMENTS}
      />
    </Container>
  );
};
